


































import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import dayjs from 'dayjs'
import { DateSchedule } from '@/types/schedule'
import { DateString } from '@/types/utils'
import CalendarCell from './CalendarCell.vue'

@Component({
  components: { CalendarCell }
})
export default class Calendar extends Vue {
  @Prop({ default: [] })
  schedules!: DateSchedule[]

  @Prop({ default: 2020 })
  year!: number

  @Prop({ default: 1 })
  month!: number

  @Prop({ default: '2020-01-01' })
  today!: DateString

  @Emit('next-month-click')
  onNextMonthClick(e: Event) {
    return e
  }

  @Emit('prev-month-click')
  onPrevMonthClick(e: Event) {
    return e
  }

  @Emit('day-click')
  onDayClick(date: string) {
    return date
  }

  get currentDate() {
    return dayjs(`${this.year}-${this.month}-1`)
  }

  get nextMonth() {
    return this.currentDate.add(1, 'month').format('M')
  }

  get prevMonth() {
    return this.currentDate.add(-1, 'month').format('M')
  }

  get displayYear() {
    return this.currentDate.format('YYYY')
  }

  get displayMonth() {
    return this.currentDate.format('M')
  }

  get days() {
    return this.getPaddedDaysInMonth(this.year, this.month)
  }

  isToday(date: string) {
    return date ? dayjs(this.today).isSame(date, 'date') : false
  }

  getSchedulesOfDay(date: string) {
    const dailySchedule = this.schedules.find(ds => ds.date === date)
    return dailySchedule ? dailySchedule.schedules : []
  }

  getDisplayDate(date: string) {
    return dayjs(date).format('D')
  }

  getDaysInMonth(year: number, month: number) {
    const firstDay = dayjs(`${year}-${month}-1`)
    const lastDay = firstDay.add(1, 'month').add(-1, 'day')
    const dates = [...Array(lastDay.date()).keys()]
    return dates.map(d => firstDay.add(d, 'day').format('YYYY-MM-DD'))
  }

  getPaddedDaysInMonth(year: number, month: number) {
    let dates = this.getDaysInMonth(year, month)
    const firstDay = dayjs(dates[0])
    const lastDay = dayjs(dates[dates.length - 1])
    if (firstDay.day() > 0) {
      const blanks = Array(firstDay.day())
      dates = blanks.concat(dates)
    }
    if (lastDay.day() < 6) {
      const blanks = Array(6 - lastDay.day())
      dates = dates.concat(blanks)
    }
    return dates
  }
}
